<template>
  <div
    data-modal-wrapper
    data-class-in="opacity-100 translate-y-0"
    data-class-out="opacity-0 translate-y-5"
    :class="wideLayout ? 'max-w-none' : 'max-w-4xl'"
    class="z-50 w-full pb-4 pl-4 pr-4 m-3 overflow-auto scrolling-touch transition-all duration-300 transform translate-y-5 bg-white shadow-xl opacity-0 max-h-vh75">
    <div class="sticky top-0 flex items-center justify-between pt-6 pb-4 mb-6 bg-white border-b-1 border-gray-85">
      <p class="uppercase font-futuraEfDemiBold">{{ heading }}</p>
      <button data-modal-close aria-label="Close"><img width="25" height="25" class="inline ml-0" src="@/assets/images/cross-black.svg" /></button>
    </div>
    <!--<button data-modal-close aria-label="Close" class="button-std" style="min-width:115px;">{{ params.cancelButton }}</button>-->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ellevio-web-info-modal',
  data() {
    return {
      buttonDisable: false
    }
  },
  props: {
    heading: {
      type: String,
      default: 'Info'
    },
    wideLayout: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
}
</script>

<style></style>
